import { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

/**
 * Column grid shared by the Customer / Shipping Address / Goods Destination
 * blocks and the notes rows: arrow toggle · narrow code column · wide name column.
 * Detail rows reuse the code / name columns so labels and values line up.
 */
export const TOGGLE_COLUMN_WIDTH = '3rem';
export const CODE_COLUMN_WIDTH = '26rem';
export const COLUMN_GAP = '1.2rem';
/** Height of the `Label` header above a select — keeps boxes without a label aligned. */
export const FIELD_LABEL_HEIGHT = '1.9rem';
/** Same height as the `filter` select control. */
export const FIELD_BOX_HEIGHT = '3.6rem';

/** Bordered read-only value box (code, name and detail values). */
export const boxBase = css`
  display: flex;
  align-items: center;
  min-height: ${FIELD_BOX_HEIGHT};
  padding: 0.6rem 1rem;

  border: 0.1rem solid ${pickColor('borderColorDark')};
  border-radius: ${({ theme }) => theme.borderRadius.base};
  background-color: ${pickColor('whiteDark')};

  font-family: 'LFT Zeno', sans-serif;
  font-size: 1.2rem;
  color: ${pickColor('black')};
  word-break: break-word;
`;
